export default __webpack_public_path__ + "static/media/kitty_bow.078a1d39.png";